export default __webpack_public_path__ + "static/media/nesto-online-order-now.319e7221.svg";